import { render } from "./sales_and_collection_analysis.vue?vue&type=template&id=af6362c2&scoped=true"
import script from "./sales_and_collection_analysis.vue?vue&type=script&lang=js"
export * from "./sales_and_collection_analysis.vue?vue&type=script&lang=js"

import "./sales_and_collection_analysis.vue?vue&type=style&index=0&id=af6362c2&scoped=true&lang=css"
import "./sales_and_collection_analysis.vue?vue&type=style&index=1&id=af6362c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af6362c2"]])

export default __exports__